import { StatusBlock } from "@/components/status-chip";
import React from "react";
import { cn } from "../styling/cn";

export class BasicErrorBoundary extends React.Component<{
  children: React.ReactNode;
  message?: React.ReactNode;
  className?: string;
}> {
  state = { error: null };

  componentDidCatch(error: Error) {
    this.setState({ error });
  }

  render() {
    if (this.state.error) {
      return (
        <StatusBlock variant="red">
          {this.props.message ?? (
            <p className={cn("text-center font-normal", this.props.className)}>
              Something went wrong.
              <br />
              Please refresh the page and try again. If the problem persists,
              please contact support.
            </p>
          )}
        </StatusBlock>
      );
    }

    return this.props.children;
  }
}

export const withErrorBoundary = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
) => {
  const WithErrorBoundary = (props?: P) => {
    return (
      <BasicErrorBoundary>
        <WrappedComponent {...(props as P)} />
      </BasicErrorBoundary>
    );
  };
  return WithErrorBoundary;
};
